import React from 'react';
import PropTypes from 'prop-types';
import './style.scss';
import ConnectedAssetsHeader from './ConnectedAssetsHeaderComponent';
import { LoadingIndicator } from 'sharedComponents';
import { apiCallStatus } from 'helpers/constants';
import { translate } from 'helpers/translateHelper';

const ConnectedAssetsComponent = ({ gatewayInformation, gatewayConnectedAssetsData, handleShowInfoClick, gatewayID, gatewaySerialNumber, isMoveValid, validationLoadingStatus, isSwitchValid, validateSwitchLoadingStatus, gatewayAssetsList, gatewayAssetsListLoadingStatus, isSwitchEgwToAnotherGateway, switchGatewayId, onResetAssetInfo }) => {
    const { loadingStatus } = gatewayConnectedAssetsData || {};

    if (loadingStatus === apiCallStatus.LOADING) {
        return <LoadingIndicator />;
    }

    if (loadingStatus === apiCallStatus.ERROR) {
        return <div>{translate('ABB.Powertrain.Frontend.errorGatewayConnectedAsset')}</div>;
    }

    return (
        <div className='connected-assets'>
            {loadingStatus === apiCallStatus.SUCCESS &&
                <ConnectedAssetsHeader gatewayInformation={gatewayInformation} gatewayConnectedAssetsData={gatewayConnectedAssetsData} handleShowInfoClick={handleShowInfoClick} gatewayID={gatewayID} gatewaySerialNumber={gatewaySerialNumber} isMoveValid={isMoveValid} validationLoadingStatus={validationLoadingStatus} isSwitchValid={isSwitchValid} validateSwitchLoadingStatus={validateSwitchLoadingStatus} gatewayAssetsList={gatewayAssetsList} gatewayAssetsListLoadingStatus={gatewayAssetsListLoadingStatus} isSwitchEgwToAnotherGateway={isSwitchEgwToAnotherGateway} switchGatewayId={switchGatewayId} onResetAssetInfo={onResetAssetInfo} />
            }

        </div>
    );
};

ConnectedAssetsComponent.propTypes = {
    gatewayInformation: PropTypes.object,
    gatewayConnectedAssetsData: PropTypes.object,
    handleShowInfoClick: PropTypes.func,
    gatewayID: PropTypes.number,
    gatewaySerialNumber: PropTypes.string,
    isMoveValid: PropTypes.bool,
    validationLoadingStatus: PropTypes.string,
    onResetAssetInfo: PropTypes.func
};

export default ConnectedAssetsComponent;
